<template>
  <div>
    <lk-modal v-model="receivedModal" :title="receiptModal ? '上传签收单' : receiptConfirmModal ? '确认签收单' : '确认收货'" width='550' :closable="false"  :mask-closable="false">
      <div class="modelContent">
        <lk-form
          v-if="!receiptConfirmModal && !receiptModal"
          label-position="left"
          class="confirmContent"
        >
          <lk-row>
            <lk-col>
              <span class="confirmMsg">是否确认购药人已签收？确认后将进行销售出库</span>
            </lk-col>
          </lk-row>
          <!-- 药联订单 -->
          <div v-if="ifShunfeng">
            <lk-row>
              <lk-col>
                <lk-form-item label='物流单号:'>
                  <span>{{expressBrother.code}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col>
                <lk-form-item label='物流签收时间:' v-if="expressBrother.acceptTime !== ''">
                  <span>{{expressBrother.acceptTime}}</span>
                </lk-form-item>
                <span class="confirmErrorMsg" v-else> 未获取到签收时间,请根据单号核对物流状态 </span>
              </lk-col>
            </lk-row>
          </div>

        </lk-form>
        <lk-form
          v-else
          :label-width='90'
          label-position="right"
        >
          <lk-row>
            <lk-col>
              <lk-form-item label='签收单:'>
                <div v-for="(item, index) in imageList" :key="index" class="mb8">
                  <Uploader style="width:250px" :able='true' v-model="item.imageUrl"></Uploader>
                </div>
                <div v-if="imageList.length < 5" style="color:#1890FF" @click="addImage">+ 添加多张</div>
              </lk-form-item>
              <lk-form-item v-if="receiptConfirmModal && imageList.length > 0">
                <span
                  class="warnInfo"
                > 请确认签收单是否正确，如不正确请重新上传签收单</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <div v-if="receiptConfirmModal">
            <lk-row >
              <lk-col >
                  <lk-form-item label='配送员:'>
                    <span>{{expressBrother.exName}}</span>
                  </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row >
              <lk-col>
                  <lk-form-item label='联系方式:'>
                    <span>{{expressBrother.exPhone}}</span>
                  </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row >
              <lk-col >
                  <lk-form-item label='上传时间:'>
                    <span>{{expressBrother.exDate}}</span>
                  </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button @click="handlerCancel">取消</lk-button>
        <lk-button :loading='confirmReceivedLoading' @click="confirmReceived" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import Uploader from '../Uploader.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  components: {
    Uploader,
  },
  props: {
    ifShunfeng: {
      type: Boolean,
      default: false,
    },
    receiptModal: {
      type: Boolean,
      default: false,
    },
    receiptConfirmModal: {
      type: Boolean,
      default: false,
    },
    receivedModal: {
      type: Boolean,
    },
    expressBrother: {
      type: Object,
    },
    saleExpressReceipt: {
      type: Object,
    },
    saleOrderId: {
      type: Number,
    },
    imageList: {
      type: Array,
    },
  },
  data() {
    return {
      confirmReceivedLoading: false,
    };
  },
  computed: { },
  methods: {
    addImage() {
      this.imageList.push({ imageUrl: '' });
    },
    handlerCancel() {
      this.resetProps();
    },
    imagesIsEmpty() {
      return this.imageList.filter(item => item.imageUrl != '').length <= 0;
    },
    confirmReceived() {
      if (this.receiptModal && this.imagesIsEmpty()) {
        this.$Message.error('请选择图片');
        return;
      }
      if (this.receiptConfirmModal && this.imagesIsEmpty()) {
        this.$Message.error('请选择图片');
        return;
      }
      const finalSale = this.receiptModal || this.receiptConfirmModal ? sale.checkReceipt : sale.confirmReceipt;
      this.confirmReceivedLoading = true;
      const param = {
        orderId: this.saleOrderId,
        ...this.saleExpressReceipt,
      };
      if (this.receiptModal || this.receiptConfirmModal) {
        const tempList = this.imageList.filter(item => item.imageUrl != '');
        param.imgUrls = tempList.map(item => item.imageUrl);
      }
      const msg = this.receiptModal ? '上传签收单成功' : this.receiptConfirmModal ? '确认签收单成功' : '确认收货成功';
      finalSale(param).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success(msg);
          this.$emit('upSuccess');
        } else if (res.data.status === 71056) {
          this.$Modal.confirm({
            title: '确认收货',
            content: '<div style="color:red;">该订单取消运单后未重下运单，确认收货后配送方式将更新为”自配送“</div>',
            onOk: () => {
              this.confirmReceiveGood(this.saleOrderId, true, this.saleExpressReceipt);
            },
          });
        } else {
          this.$Message.error(res.data.error);
        }
        this.confirmReceivedLoading = false;
        this.resetProps();
      }).catch((err) => {
        this.confirmReceivedLoading = false;
        utils.handleError(err);
      });
    },
    resetProps() {
      this.$emit('update:receivedModal', false);
      setTimeout(() => {
        this.$emit('update:receiptModal', false);
        this.$emit('update:receiptConfirmModal', false);
      }, 500);
    },
    confirmReceiveGood(orderId, bool, saleExpressReceipt) {
      const param = {
        orderId,
        reTrySfOrderConfire: bool,
        ...saleExpressReceipt,
      };
      sale.confirmReceipt(param).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('操作成功');
          this.$emit('upSuccess');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  watch: {},
  mounted() { },
};
</script>
<style lang="less" >
  .modelContent {
    .confirmContent {
      margin-left: 26px;
    }
    .confirmMsg {
      display: inline-block;
      line-height: 32px;
    }
    .ivu-form-item {
      margin-bottom: 0px;
    }
    .confirmErrorMsg {
      color: red;
      display: inline-block;
      line-height: 32px;
    }
    .warnInfo {
      color: red;
      transform:scale(0.6);
    }
  }
</style>
